import { BaseQueryOptions } from '@apollo/client';

import {
  useCustomerQuery as useApolloCustomerQuery,
  CustomerQueryVariables,
  useGetCommunicationPreferencesForAllSubBrandsQuery as useApolloGetCommunicationPreferencesForAllSubBrandsQuery,
  GetCommunicationPreferencesForAllSubBrandsQueryVariables,
} from '@occc/graphql';

import { useQuery } from '../utils';

export const useCustomerQuery = (baseOptions?: BaseQueryOptions<CustomerQueryVariables>) =>
  useQuery(useApolloCustomerQuery, baseOptions);

export const useGetCommunicationPreferencesForAllSubBrandsQuery = (
  baseOptions?: BaseQueryOptions<GetCommunicationPreferencesForAllSubBrandsQueryVariables>,
) => useQuery(useApolloGetCommunicationPreferencesForAllSubBrandsQuery, baseOptions);
